module.exports = __webpack_public_path__ + "static/media/bg1.e63a0467.webp";